import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../styles/proposition-bets-widget.module.scss";
import {LINK_REL, WIDGET_TYPES} from "../../../../core/consts";
import {APP} from "../../../../core/app/consts";
import {PREDICTION_WIDGET} from "../../../prediction-widget/predictions-widget.consts";
import {useBookieClick} from "../../../../infrastructure/hooks/useBookieClick";
import {PROPOSITION_BETS} from "../../proposition-bets-widgets.consts";
import {Link} from "../../../../core/components/link/link";

export const PropositionBetsWidgetRowButton = observer(({controller, row}) => {
  const {state, config} = controller;
  const {bookmaker, game, currentLinkModel, isEnded} = state;
  const {source} = config;
  const {lineTypeId} = row;

  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
    bookieId: bookmaker?.id,
    bookieName: bookmaker?.name,
    urlLink: bookmaker?.link,
    widget: APP.ANALYTICS.WIDGET_TYPES[WIDGET_TYPES.propositionBets],
    impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.tooltip,
    hasOdds: !!bookmaker,
    source,
    subSource: PREDICTION_WIDGET.TABS_LABEL.props,
    status: game.statusGroup,
    marketType: lineTypeId,
    buttonType: PROPOSITION_BETS.ANALYTICS.BOOKIE_BUTTON_TYPE.betNow,
    currentLinkModelName: currentLinkModel?.name
  });

  const buttonProps = {
    model: bookieHrefModel,
    rel: LINK_REL.SPONSORED_NOOPENER,
    className: classNames(styles.bet_now_button),
    onClick: (e) => {
      e.stopPropagation();

      return onBookieClick();
    }
  }

  return !isEnded && bookmaker?.actionButton?.label ? <Link {...buttonProps}>{bookmaker?.actionButton?.label}</Link> : null
});
